module.exports = __webpack_public_path__ + "img/1495.600e6f69.gif";